export enum TrackingStatus {
    NEW = 'NEW',
    ALIVE = 'ALIVE',
    DEAD = 'DEAD',
    INVALID = 'INVALID',
}

interface Tracking {
    status: TrackingStatus | null;
}

export type { Tracking };
